import React from "react";
import { Card, CardBody, CardHeader, Row, Col } from "reactstrap";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const Acquisitions = () => {
  const primary = "#7366ff";
  const secondary = "#f73164";

  // Retrieve data from the Redux store using useSelector hook
  const dashboardReducerdData = useSelector((state) => state.dashboardReducer);

  //

  let countData = {
    application_percentage: 0,
    shortlisted_percentage: 0,
    rejected_percentage: 0,
    pending_percentage: 0,
  };
  // Check if dashboardReducerdData is not loading and contains the necessary data
  if (
    !dashboardReducerdData.isLoading &&
    dashboardReducerdData.data &&
    dashboardReducerdData.data.data
  ) {
    countData = dashboardReducerdData.data.data;
  }

  console.log("countData", countData);
  const {
    application_percentage,
    shortlisted_percentage,
    rejected_percentage,
    pending_percentage,
  } = countData;

  const createProgressChart = (title, percentage, color) => ({
    series: [
      {
        name: title,
        data: [percentage],
      },
    ],
    options: {
      chart: {
        height: 70,
        type: "bar",
        stacked: true,
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "15%",
          colors: {
            backgroundBarColors: [color],
            backgroundBarOpacity: 0.2,
          },
        },
      },
      colors: [color],
      stroke: {
        width: 0,
      },
      fill: {
        colors: [color],
        type: "gradient",
        opacity: 1,
        gradient: {
          gradientToColors: [color],
        },
      },
      title: {
        floating: true,
        offsetX: -10,
        offsetY: 5,
        text: title,
        style: {
          fontSize: "16px",
          fontFamily: "Roboto, sans-serif",
          fontWeight: 500,
        },
      },
      subtitle: {
        floating: true,
        align: "right",
        offsetY: 0,
        text: `${percentage}%`,
        style: {
          fontSize: "11px",
        },
      },
      tooltip: {
        enabled: false,
      },
      xaxis: {
        categories: [title],
      },
      yaxis: {
        max: 100,
      },
      responsive: [
        {
          breakpoint: 767,
          options: {
            title: {
              style: {
                fontSize: "16px",
              },
            },
          },
        },
      ],
    },
  });

  const progress1 = createProgressChart(
    "Applications",
    application_percentage,
    primary
  );
  const progress2 = createProgressChart(
    "Shortlisted",
    shortlisted_percentage,
    secondary
  );
  const progress3 = createProgressChart(
    "On-hold",
    pending_percentage,
    "#ffc107"
  );
  const progress4 = createProgressChart(
    "Rejected",
    rejected_percentage,
    secondary
  );

  return (
    <Col xxl="4" xl="7" md="6" sm="5" className="box-col-6">
      <Card>
        <CardHeader className="card-no-border mb-0">
          <Row>
            <Col xs="9">
              <h5>Acquisitions</h5>
            </Col>
            <Col xs="3" className="text-end">
              {/* Optional header content */}
            </Col>
          </Row>
        </CardHeader>

        <CardBody className="">
          <div className="chart-container progress-chart ">
            <div id="progress1">
              <Chart
                options={progress1.options}
                series={progress1.series}
                height="71"
                type="bar"
              />
            </div>
            <div id="progress2">
              <Chart
                options={progress2.options}
                series={progress2.series}
                height="71"
                type="bar"
              />
            </div>
            <div id="progress3">
              <Chart
                options={progress3.options}
                series={progress3.series}
                height="71"
                type="bar"
              />
            </div>
            <div id="progress4">
              <Chart
                options={progress4.options}
                series={progress4.series}
                height="71"
                type="bar"
              />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Acquisitions;
